import { Currency } from '@sorare/core/src/__generated__/globalTypes';
import { UserAccountEntries } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/UserAccountEntries';

const Page = () => {
  return <UserAccountEntries currency={Currency.FIAT} />;
};

export default Page;
